import { useEffect, useState } from "react";

import AuthenticatedTenant from "../../Layouts/AuthenticatedLayoutTenant";
import Privacy from "../_Partials/Privacy";
import WorkPath from "../../UI-component/WorkPath";
import DynamicStepContent from "../../UI-component/DynamicStepContent";
import { ServiceDetailsAPI } from "../../Apis/ServiceDetailsAPI";

import { useDispatch } from "react-redux";
import stepSlice from "../../context/StepsContext";
import { useLocation } from "react-router-dom";
import General from "../_Partials/cemetery/General";
import Specific from "../_Partials/cemetery/Specifis";
import Summary from "../_Partials/cemetery/Summary";


export default function Cemetery(props) {
  const dispatcher = useDispatch();
  const [header, setHeader] = useState("");
  const [user, setUser] = useState("");
  const [data, setData] = useState({});
  const [testData, setTestData] = useState({});
  const [bread, setBread] = useState({});

  const location = useLocation();

  useEffect(() => {
    //inizioalize first view first step
    if (localStorage.getItem("configuration")) {
      clearStore();
      const config = JSON.parse(localStorage.getItem("configuration"));
      setHeader(config.data.current);
    }

    if (localStorage.getItem("user")) {
      clearStore();
      const user = JSON.parse(localStorage.getItem("user"));
      setUser(user);
    }

    (async () => {
      try {
        const bread = await ServiceDetailsAPI.getBreadcrumbs("RSD");
        setBread(bread);
        await getData();
      } catch (err) {
        console.log(err);
      }
    })()

    if (location.state) {
      dispatcher(stepSlice.actions.onDraftData({ data: location.state.data, saved: false }));
    }

    if (!location.state) {
      (async () => {
        try {
          const saved = await ServiceDetailsAPI.getSaved("rsd");

          if (!saved.success) {
            return;
          }

          // console.log("enter hereee");
          // setTestData(saved?.data);
          dispatcher(stepSlice.actions.onDraftData({ data: saved?.data, saved: false }));

        } catch (err) {
          console.log(err);
        }
      })()
    }
  }, []);


  //Clears the context session
  const clearStore = () => {
    // console.log("clearing store");
    dispatcher(stepSlice.actions.clear())
  }

  //Retrieves the data from the backend for the creation of the page
  const getData = async () => {
    try {
      const res = await ServiceDetailsAPI.getServiceDetails(props.code);

      if (!res.success) return;

      const data = res.data?.data;
      setData(data);
    } catch (err) {
      console.log(err);
    }
  }

  /* console.log(bread); */

  return (
    <AuthenticatedTenant auth={user} errors={props.errors} header={header}>
      <WorkPath workPathInfo={{
        base: ["Home", header?.siteUrl],
        medium: ["Servizi", header?.siteUrl + "servizi/"],
        category: [bread.category_name, bread.category_url],
        serviceName: [bread.service_name, bread.service_url],
        end: "Servizio digitale",
      }} />

      <div className="container" id="main-container">
        <div className="row justify-content-center" >
          <DynamicStepContent service={props.code}
            successTitle={"Richiesta sepoltura di un defunto"}
            successDesc={`
            Inserisci le informazioni necessarie per richiedere la sepoltura di un defunto.<br>
            Potrai ricontrollare tutti i dati nel riepilogo, prima di inviare la richiesta.
          `}
            stepList={["INFORMATIVA SULLA PRIVACY", "DATI GENERALI", "DATI SPECIFICI", "RIEPILOGO"]} steps={[
              {
                component: Privacy, info: {
                  description: `Il ${JSON.parse(localStorage.getItem("configuration")).data.current.description}
                  esercita compiti e funzioni e gestisce servizi come indicato negli artt. 13/14 del Testo Unico Enti Locali (D.lgs. 267/2000 e ss integrazioni).
                  In questo contesto procede al trattamento dei dati personali dell’interessato necessari per fornire ogni tipo 
                  di servizio nel rispetto della normativa vigente (codice protezione dati personali e Regolamento europeo 16/679).
                  Per una completa informazione si invita a prendere conoscenza del contenuto della informativa resa ex art. 13
                  Regolamento europeo.`,
                  linkPrivacy: "",
                }
              },
              { component: General, info: { data: testData, code: props.code } },
              { component: Specific, info: { code: props.code } },
              { component: Summary, info: { code: props.code } },
            ]} />

        </div>
      </div>

    </AuthenticatedTenant>
  );
}

